var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Faq"},[_c('Hero',{attrs:{"src":"../assets/faq/hero.jpg"}},[_c('h1',[_vm._v("Dažniausiai užduodami klausimai")])]),_c('Sect',[_c('Wrap',{staticClass:"lg"},_vm._l((_vm.faqs),function(ref,index){
var q = ref.q;
var a = ref.a;
return _c('Qa',{key:index,attrs:{"answer":a,"question":q}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }